module.exports = __webpack_public_path__ + "img/周致宽.446d66a1.jpg";